import makeLookupModal from "../../UI/LookupModal/LookupModal";
import ConcentrationLookup from "./ConcentrationLookup";
import SpecializationLookup from "./SpecializationLookup";
import MinorLookup from "./MinorLookup";
import MajorLookup from "./MajorLookup";
export const MajorLookupModal = makeLookupModal(MajorLookup, {
    pluralEntityName: "Majors",
});
export const MinorLookupModal = makeLookupModal(MinorLookup, {
    pluralEntityName: "Minors",
});
export const ConcentrationLookupModal = makeLookupModal(ConcentrationLookup, {
    pluralEntityName: "Concentrations",
});
export const SpecializationLookupModal = makeLookupModal(SpecializationLookup, {
    pluralEntityName: "Specializations",
});
